var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStadtIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 41,
    viewBox: "0 0 30 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0178 1.39014C7.28832 1.39014 1 7.67428 1 15.3985C1 24.9845 13.5445 39.0573 14.0786 39.6517C14.5803 40.2101 15.4561 40.2091 15.9569 39.6517C16.491 39.0573 29.0355 24.9845 29.0355 15.3985C29.0354 7.67428 22.7471 1.39014 15.0178 1.39014Z",
    stroke: "#B1B1B1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9 8.4L23.4 16.9L22.7 17.6L21 15.9V24.4H17.4V19.1H12.3V24.4H8.8V15.9L7.1 17.6L6.4 16.9L14.9 8.4ZM14.9 7L14.2 7.7L5.7 16.2L5 16.9L5.7 17.6L6.4 18.3L7.1 19L7.8 18.3V24.4V25.4H8.8H12.4H13.4V24.4V20.1H16.5V24.4V25.4H17.5H21.1H22.1V24.4V18.3L22.8 19L23.5 18.3L24.2 17.6L24.9 16.9L24.2 16.2L15.7 7.7L14.9 7Z",
    fill: "#B1B1B1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStadtIcon);
export default __webpack_public_path__ + "static/media/stadtIcon.404c24f3b5f2699009db60a3ad8326a7.svg";
export { ForwardRef as ReactComponent };